var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import React, { useState } from 'react';
import PropTypes from 'prop-types';
import A2HSContext from './withA2HS';

var initialState = {
  deferredPrompt: function deferredPrompt() {},
  isAppInstallable: false,
  isAppInstalled: false
};

var A2HSProvider = function A2HSProvider(_ref) {
  var children = _ref.children;

  var _useState = useState(initialState),
      state = _useState[0],
      setA2HPState = _useState[1];

  window.addEventListener('beforeinstallprompt', function (e) {
    // Prevent Chrome 67 and earlier from automatically showing the prompt
    e.preventDefault();
    // Stash the event so it can be triggered later.
    setA2HPState({ deferredPrompt: e, isAppInstallable: true });
    console.log('deffered prompt saved');
  });

  window.addEventListener('appinstalled', function (evt) {
    setA2HPState({ isAppInstalled: true });
  });

  return React.createElement(
    A2HSContext.Provider,
    { value: _extends({}, state, { setA2HPState: setA2HPState }) },
    children
  );
};

export default A2HSProvider;